import {
  getLogActivities,
  type LogActivityParams,
  getEntities,
  getResourceEntity,
  getLogActivityDetail,
  getLogStatic,
  login,
} from "@/api/logActivityService";
import { CACHE_TIME } from "@/lib/cacheConfig";
import { queryKeys } from "@/lib/queryKeys";
import { useMutation, useQuery } from "@tanstack/react-query";

export const useGetLogActivities = (params: LogActivityParams) => {
  return useQuery({
    queryKey: queryKeys.logActivity.list(),
    queryFn: () => getLogActivities(params),
    staleTime: CACHE_TIME.SHORT,
  });
};

export const useGetLogActivityDetail = (id: number) => {
  return useQuery({
    queryKey: queryKeys.logActivity.detail(id),
    queryFn: () => getLogActivityDetail(id),
    staleTime: CACHE_TIME.SHORT,
    enabled: !!id
  });
};

export const useGetLogStatic = (searchDate: string) => {
  return useQuery({
    queryKey: queryKeys.logActivity.static(searchDate),
    queryFn: () => getLogStatic(searchDate),
    staleTime: CACHE_TIME.SHORT,
  });
};

export const useGetResourceEntity = () => {
  return useQuery({
    queryKey: queryKeys.logActivity.resource(),
    queryFn: () => getResourceEntity(),
    staleTime: CACHE_TIME.MASTER_DATA,
  });
};

export const useGetEntities = () => {
  return useQuery({
    queryKey: queryKeys.logActivity.entity(),
    queryFn: () => getEntities(),
    staleTime: CACHE_TIME.MASTER_DATA,
  });
};

export const useLogin = () => {
  return useMutation({
    mutationFn: () => login(),
  });
};